module.exports = __webpack_public_path__ + "img/estacionamiento-3.dc545ae6.jpeg";